<template>
  <div class="nav-right-menu">
    <slot />
    <header-search v-if="hasLayout('search')" :all-menu="allMenu" />
    <header-message
      v-if="hasLayout('message')"
      :message-list="messageList"
      :message-total="messageTotal"
      :user-info="userInfo"
      @setMessageList="handleEmit($event, 'setMessageList')"
      @toSendMassage="handleEmit($event, 'toSendMassage')"
    />
    <header-full v-if="hasLayout('full')" />
    <header-settings v-if="hasLayout('settings')" @handleEmit="($event, 'handleSetting')" />
    <header-language
      v-if="hasLayout('language')"
      :language-list="languageList"
      :language="language"
      @handleLanguage="handleEmit($event, 'handleLanguage')"
    />
    <header-account
      v-if="userInfo"
      :user-info="userInfo"
      :dropdown-menu="dropdownMenu"
      @handleAccount="handleEmit($event, 'handleAccount')"
    />
  </div>
</template>

<script>
import HeaderFull from './components/HeaderFull'
import HeaderLanguage from './components/HeaderLanguage'
import HeaderSettings from './components/HeaderSettings'
import HeaderSearch from './components/HeaderSearch'
import HeaderMessage from './components/HeaderMessage'
import HeaderAccount from './components/HeaderAccount'
import '../../../../lib/styles/components/NavRightMenu.scss'

export default {
  name: 'NavRightMenu',
  components: {
    HeaderLanguage,
    HeaderFull,
    HeaderSearch,
    HeaderMessage,
    HeaderAccount,
    HeaderSettings
  },
  props: {
    // 菜单数据
    layout: {
      type: String,
      default: 'search, message, full, language'
    },
    // 用于搜素路径
    allMenu: {
      type: Array,
      default: () => []
    },
    // 消息数据
    messageList: {
      type: Array,
      default: () => []
    },
    // 消息总条数
    messageTotal: {
      type: Number,
      default: 0
    },
    // 语言数据
    languageList: {
      type: Array,
      default: () => []
    },
    // 默认语言
    language: {
      type: String,
      default: 'zh_CN'
    },
    // 用户信息
    userInfo: {
      type: Object,
      default: () => {}
    },
    // 用户下拉菜单
    dropdownMenu: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    // 用于判断是否需要显示
    hasLayout() {
      return (name) => {
        // 将layout拆分为数组
        const v = this.layout.split(',').map((item) => item.trim())
        return v.includes(name)
      }
    }
  },
  methods: {
    handleEmit(v, name) {
      this.$emit(name, v)
    }
  }
}
</script>
